import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);
const routes = [
    //其他路由
    {
        path: '/index',
        name: 'index',
        meta: {
            title: "鄂前旗疾病预防控制中心"
        },
        component: () => import('@/views/Index.vue')
    },
    {
        path: '/personal',
        name: 'personal',
        meta: {
            title: "个人中心"
        },
        component: () => import('@/views/Personal.vue')
    },
    {
        path: '/user',
        name: 'user',
        meta: {
            title: "用户管理"
        },
        component: () => import('@/views/User.vue')
    },
    {
        path: '/occDisSur',
        name: 'occDisSur',
        meta: {
            title: "健康调查"
        },
        component: () => import('@/views/OccDisSur.vue')
    },
    {
        path: '/order',
        name: 'order',
        meta: {
            title: "订单列表"
        },
        component: () => import('@/views/Order.vue')
    },
    {
        path: '/orderDetail',
        name: 'orderDetail',
        meta: {
            title: "订单详情"
        },
        component: () => import('@/views/OrderDetail.vue')
    },
    {
        path: '/report',
        name: 'report',
        meta: {
            title: "报告查询"
        },
        component: () => import('@/views/Report.vue')
    },
    {
        path: '/reportDetail',
        name: 'reportDetail',
        meta: {
            title: "报告详情"
        },
        component: () => import('@/views/ReportDetail.vue')
    },
    {
        path: '/buyCard',
        name: 'buyCard',
        meta: {
            title: "网上购卡"
        },
        component: () => import('@/views/BuyCard.vue')
    },
    {
        path: '/buyCardDetail',
        name: 'buyCardDetail',
        meta: {
            title: "卡套详情"
        },
        component: () => import('@/views/BuyCardDetail.vue')
    },
    {
        path: '/onlineBooking',
        name: 'onlineBooking',
        meta: {
            title: "在线预约"
        },
        component: () => import('@/views/OnlineBooking.vue')
    },
    {
        path: '/appointment',
        name: 'appointment',
        meta: {
            title: "我的预约"
        },
        component: () => import('@/views/Appointment.vue')
    },
    {
        path: '/appointmentDetail',
        name: 'appointmentDetail',
        meta: {
            title: "预约详情"
        },
        component: () => import('@/views/AppointmentDetail.vue')
    },
    {
        path: '/companyProfile',
        name: 'companyProfile',
        meta: {
            title: "医院简介"
        },
        component: () => import('@/views/CompanyProfile.vue')
    },
    {
        path: '/physicalExaminationNotice',
        name: 'physicalExaminationNotice',
        meta: {
            title: "体检须知"
        },
        component: () => import('@/views/PhysicalExaminationNotice.vue')
    },
    {
        path: '/physicalExaminationGuidance',
        name: 'physicalExaminationGuidance',
        meta: {
            title: "体检引导"
        },
        component: () => import('@/views/PhysicalExaminationGuidance.vue')
    },
    {
        path: '/branchInformation',
        name: 'branchInformation',
        meta: {
            title: "分院信息"
        },
        component: () => import('@/views/BranchInformation.vue')
    },
    {
        path: '/401',
        name: '401',
        meta: {
            title: "401页面"
        },
        component: () => import('@/views/err/401.vue')
    },
    {
        path: '/404',
        name: '404',
        meta: {
            title: "404页面"
        },
        component: () => import('@/views/err/404.vue')
    },
    {
        path: '/500',
        name: '500',
        meta: {
            title: "500页面"
        },
        component: () => import('@/views/err//500.vue')
    },
    {
        path: '*',
        redirect: '/index'
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        // return 期望滚动到哪个的位置
        return {
            x: 0,
            y: 0
        }
    }
});

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    document.title = to.meta && to.meta.title ? to.meta.title : "体检中心";
    next()
})

// 这个是为了避免一个报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router;
